<template>

    <authentication-layout :title="__('Email Verification')">

        <div class="mb-4 text-sm text-gray-600">
            {{ __('Thanks! Before getting started, could you verify your email address by clicking on the link we just emailed to you? If you did not receive the email, we will gladly send you another.') }}
        </div>

        <div class="mb-4 font-medium text-sm text-green-600"
            v-if="verificationLinkSent">

            {{ __('A new verification link has been sent to the email address you provided during registration.') }}

        </div>

        <form @submit.prevent="submit">

            <div class="mt-4 flex items-center justify-start">

                <Button :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing">

                    {{ __('Resend Verification Email') }}

                </Button>

                <Link :href="route('logout')"
                    method="post"
                    as="button"
                    class="underline text-sm text-gray-600 hover:text-gray-900">

                    {{ __('Log Out') }}

                </Link>

            </div>
        </form>

    </authentication-layout>

</template>

<script>
import { defineComponent } from 'vue'
import AuthenticationLayout from "@/Layouts/AuthenticationLayout";
import Button from '../../Components/Button.vue';
import { Link } from '@inertiajs/inertia-vue3';

export default defineComponent({

    components: {
        AuthenticationLayout,
        Button,
        Link,
    },

    props: {
        status: String
    },

    data() {
        return {
            form: this.$inertia.form()
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('verification.send'))
        },
    },

    computed: {
        verificationLinkSent() {
            return this.status === 'verification-link-sent';
        }
    }
})
</script>
